

import styled from "styled-components";
import { Link } from "react-router-dom";


export const PostContainer = styled.div`
    padding: 40px 0;
    max-width: 800px;
    margin: auto;

    h1 {
        font-size: 40px;
        color: #02391E;
        margin-bottom: 15px;
        line-height: 1.2;
    }

`;

export const PostMeta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px; /* Espaçamento entre os itens de metadados */
    padding: 20px;
    margin-bottom: 30px;
    background-color: #f9f9f9;
    border-left: 4px solid #02391E;
    color: #575757;
    font-size: 16px;

    .category {
        font-weight: 500;
        strong {
            color: #333;
        }
    }
    
    .tags-container {
        display: flex;
        flex-wrap: wrap;
        gap: 8px; /* Espaçamento entre as tags */
    }
`;


export const TagBadge = styled.span`
    display: inline-block;
    padding: 5px 12px;
    background-color: #e0e0e0;
    color: #333;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 500;
`;


export const PostContent = styled.div`
    color: #333;
    line-height: 1.8;
    font-size: 18px;

    h2, h3, h4 {
        color: #02391E;
        margin-top: 40px;
        margin-bottom: 20px;
    }

    p {
        margin-bottom: 20px;
    }

    ul, ol {
        margin-left: 30px;
        margin-bottom: 20px;
    }

    li {
        margin-bottom: 10px;
    }

    img {
        max-width: 100%;
        height: auto;
        border-radius: 8px;
        margin: 20px 0;
    }
    
   

    table {
        width: 100%;
        border-collapse: collapse; 
        margin: 30px 0;
        font-size: 16px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12);
        border-radius: 8px;
        overflow: hidden; 
    }

    th, td {
        padding: 12px 15px; 
        border: 1px solid #ddd; 
        text-align: left;
    }

    th {
        background-color: #f2f2f2; 
        color: #02391E; 
        font-weight: 600;
    }

    tr {
        border-bottom: 1px solid #ddd;
    }


    tbody tr:nth-child(even) {
        background-color: #f9f9f9;
    }

    tbody tr:hover {
        background-color: #f1f1f1; 
    }
`;



export const BannerContainer = styled.div`
    position: relative;
    width: 100%;
    height: 65vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;


export const PostHeaderImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${props => props.src});
    background-size: cover;
    background-position: center;

 
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.45);
        z-index: 1;
    }
`;


export const BannerContent = styled.div`
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1200px; 
    padding: 0 40px;
    color: white;
`;

export const BannerTitle = styled.h1`
    font-size: 48px;
    text-align: center;
    flex-grow: 1; 
    padding: 0 30px;
    line-height: 1.3;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
`;


export const NavArrow = styled(Link)`
    cursor: pointer;
    transition: transform 0.3s ease;

    img {
        width: 40px;
        height: 40px;
        filter: brightness(0) invert(1); 
        opacity: 0.8;
    }

    &:hover {
        transform: scale(1.1);
        img {
            opacity: 1;
        }
    }

    &.disabled {
        opacity: 0.2;
        pointer-events: none;
    }
`;


export const ScrollDownContainer = styled.div`
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    cursor: pointer;
    transition: transform 0.3s ease;

    img {
        width: 35px;
        height: 35px;
        filter: brightness(0) invert(1);
        opacity: 0.8;
    }

    &:hover {
        transform: scale(1.1);
    }
`;


export const NextPostBanner = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    min-height: 350px;
    text-decoration: none;
    position: relative;
    background-image: url(${props => props.bgimage});
    background-size: cover;
    background-position: center;
    margin-top: 60px;
    color: white;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        transition: background-color 0.3s ease;
    }

    &:hover::before {
        background-color: rgba(0, 0, 0, 0.65);
    }
`;


export const NextPostContent = styled.div`
    position: relative;
    z-index: 1;

    span {
        font-size: 18px;
        font-weight: 500;
    }

    h3 {
        font-size: 36px;
        margin-top: 10px;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    }
`;

